// Native localization remains usable without this optional auto-submit enhancement.
function enhanceLumeriiaFooter(root = document) {
  for (const select of root.querySelectorAll('[data-lumeriia-country]:not([data-enhanced])')) {
    select.addEventListener('change', () => select.form.requestSubmit());
    select.dataset.enhanced = 'true';
  }
}
enhanceLumeriiaFooter();
document.addEventListener('shopify:section:load', (event) => enhanceLumeriiaFooter(event.target));
